import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import LinePlaneFlyIcon from 'LuxKit/Icons/line/LinePlaneFlyIcon'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import Group from 'components/utils/Group'
import type { PropsWithChildren, ReactNode } from 'react'
import React from 'react'
import { useIntl } from 'react-intl'

interface Props extends Utils.PropsWithDataAttributes, Omit<React.ComponentProps<typeof Group>, 'direction' | 'verticalAlign' | 'gap'> {
  callToAction?: ReactNode
  title: 'Hotel' | 'Hotel + flights' | undefined
}

function AccommodationPackageTilePricingBlock(props: PropsWithChildren<Props>) {
  const {
    callToAction,
    children,
    title,
    ...rest
  } = props

  const intl = useIntl()

  const titleText = (() => {
    if (!title) return undefined
    if (title === 'Hotel') {
      return intl.formatMessage({
        id: 'JZ3-s1_WRvpPKN5mTma9',
        defaultMessage: 'Hotel',
        description: 'Title label shown above the package price for hotel-only packages.',
      })
    }
    if (title === 'Hotel + flights') {
      return intl.formatMessage({
        id: 'Us6SJTbOPnAQcYJmNn5S',
        defaultMessage: 'Hotel + flights',
        description: 'Title label shown above the package price for hotel and flights packages.',
      })
    }
    return title
  })()

  return <Group
    {...rest}
    direction="vertical"
    verticalAlign="space-between"
    gap={20}
  >
    <VerticalSpacer gap={8}>
      {title && <CaptionTextBlock
        variant="large"
        weight="bold"
        startIcon={title === 'Hotel + flights' && <LinePlaneFlyIcon />}
      >
        {titleText}
      </CaptionTextBlock>}
      {children && <div>{children}</div>}
    </VerticalSpacer>

    {callToAction}
  </Group>
}

export default AccommodationPackageTilePricingBlock
